/* eslint-disable @typescript-eslint/no-explicit-any */
// newTemplateMessageSendSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';

import axios from 'axios';
import { sendRecipientDetails } from '../../Utils/recipientDetailsUtils';

interface TemplateMessageVariables {
  [key: string]: string;
}

interface SendNewTemplateMessagePayload {
  template: string;
  variables: TemplateMessageVariables;
  current_recipient: string;
  scheduled_time?: number;
}

interface NewTemplateMessageState {
  variables: TemplateMessageVariables;
  isSending: boolean;
  error: string | null;
}

const initialState: NewTemplateMessageState = {
  variables: {},
  isSending: false,
  error: null
};

export const sendNewTemplateMessage = createAsyncThunk(
  'newTemplateMessage/send',
  async (payload: SendNewTemplateMessagePayload, { getState }) => {
    const state = getState() as any;
      const token = state.auth.token;
    
          const response = await axios.post('https://api.insightssystem.com/api:uYdlVwac/web/send/template', payload, {
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: token })
        }
      });

      // Send recipient details to API
      await sendRecipientDetails({ phone_number: payload.current_recipient }, token);

    return response.data;
  }
);

const newTemplateMessageSendSlice = createSlice({
  name: 'newTemplateMessage',
  initialState,
  reducers: {
    updateNewTemplateVariable: (state, action) => {
      const { key, value } = action.payload;
      state.variables[key] = value;
    },
    resetNewTemplateVariables: (state) => {
      state.variables = {};
    },
    clearNewTemplateError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNewTemplateMessage.pending, (state) => {
        state.isSending = true;
        state.error = null;
      })
      .addCase(sendNewTemplateMessage.fulfilled, (state) => {
        state.isSending = false;
        state.error = null;
        state.variables = {};
      })
      .addCase(sendNewTemplateMessage.rejected, (state, action) => {
        state.isSending = false;
        state.error = action.error.message || 'Failed to send template message';
      });
  }
});

export const {
  updateNewTemplateVariable,
  resetNewTemplateVariables,
  clearNewTemplateError
} = newTemplateMessageSendSlice.actions;

export const selectNewTemplateVariables = (state: RootState) => state.newTemplateMessage.variables;
export const selectNewTemplateIsSending = (state: RootState) => state.newTemplateMessage.isSending;
export const selectNewTemplateError = (state: RootState) => state.newTemplateMessage.error;

export default newTemplateMessageSendSlice.reducer;